import { Component } from "solid-js";
import { Blob } from "./Blob";
import { Blur } from "./Blur";

export const Background: Component = () => {
  return (
    <div class="relative -z-10" aria-hidden="true">
      <div class="fixed top-0 right-0 bottom-0 left-0 overflow-hidden bg-black">
        <Blob />
        <Blur />
      </div>
    </div>
  );
};
